import { useTranslation } from 'react-i18next';
import React from 'react';
import Typography from '@src/new-components/Typography';
import DropdownCustom from '@src/new-components/Dropdown';
import { COLOR } from '@src/styles/color';

const Language = ({ dataLanguages, handleChangeFilter, dataFilter }) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const selectedLanguage = dataLanguages.find(
    (lang) =>
      lang.primaryLanguageSubTag === dataFilter.language?.primaryLanguageSubTag,
  );

  return (
    <div style={{ flex: 1 }}>
      <DropdownCustom
        variant="language-voice-mobile"
        options={dataLanguages.map((item) => ({
          label: item?.name?.[language],
          value: item.primaryLanguageSubTag,
        }))}
        onChange={(value) => handleChangeFilter('language', value)}
        title={
          <Typography
            variant="body-14-medium"
            color={
              selectedLanguage ? COLOR.descriptionGray : COLOR.descriptionUpload
            }
          >
            {t(selectedLanguage?.name?.[language])}
          </Typography>
        }
        value={dataFilter.language?.primaryLanguageSubTag}
        searchable
        searchPlaceholder={t('search')}
      />
    </div>
  );
};

export default Language;
